import { Icon } from "@circleco/compass/components/Icon";

import { t } from "@/i18n-js/instance";

import type { WidgetToggleButtonProps } from "./types";

export const WidgetToggleButton = ({
  expanded,
  onClick,
}: WidgetToggleButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={
      expanded
        ? t("floating_widget_button.minimize")
        : t("floating_widget_button.expand")
    }
    aria-expanded={expanded}
    className="hover:bg-secondary-hover focus-visible:bg-secondary-hover flex size-10 shrink-0 items-center justify-center rounded-full p-2 transition-colors focus-visible:outline-none"
  >
    <Icon
      name={expanded ? "chevron-right" : "chevron-left"}
      size="sm"
      color="primary"
    />
  </button>
);
